var React = require('react');

function Dash (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0.833333C0 0.373083 0.3731 0 0.833333 0H15.8333C16.2936 0 16.6667 0.373083 16.6667 0.833333C16.6667 1.29358 16.2936 1.66667 15.8333 1.66667H0.833333C0.3731 1.66667 0 1.29358 0 0.833333Z"}));
}

Dash.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Dash;

Dash.default = Dash;
